import React from 'react';
import { MdEdit } from 'react-icons/md';
import { IoImagesOutline } from 'react-icons/io5';

interface GalleryPlaceholderProps {
  restaurantName?: string;
  onSuggestEdit: () => void;
}

const GalleryPlaceholder: React.FC<GalleryPlaceholderProps> = ({ 
  restaurantName = "this restaurant",
  onSuggestEdit 
}) => {
  return (
    <div className="max-w-6xl mx-auto sm:px-0 lg:px-4 py-0 mt-20">
      <div className="relative overflow-hidden rounded-xl h-64 sm:h-80 lg:h-[380px] bg-gray-100">
        
        {/* Subtle gray decorative circles */}
        <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-gray-200/40 blur-2xl" />
        <div className="absolute -bottom-16 -left-16 w-56 h-56 rounded-full bg-gray-300/30 blur-2xl" />
        <div className="absolute top-1/3 right-8 w-32 h-32 rounded-full bg-gray-200/20 blur-xl" />
        
        {/* Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          {/* Icon */}
          <div className="w-16 h-16 sm:w-20 sm:h-20 mb-4 rounded-full bg-gray-200 flex items-center justify-center">
            <IoImagesOutline className="w-8 h-8 sm:w-10 sm:h-10 text-gray-500" />
          </div>
          
          {/* Text */}
          <div className="text-center px-4 mb-6">
            <p className="text-gray-600 text-sm sm:text-base">
              Help <span className="font-semibold">{restaurantName}</span> improve their listing
            </p>
          </div>
          
          {/* CTA Button */}
          <button
            onClick={onSuggestEdit}
            className="group bg-gray-800 hover:bg-gray-900 text-white font-semibold px-5 py-2.5 sm:px-6 sm:py-3 rounded-full text-sm sm:text-base transition-all duration-300 hover:shadow-lg hover:scale-105 flex items-center gap-2"
          >
            <MdEdit className="w-4 h-4 sm:w-5 sm:h-5" />
            <span>Suggest an edit</span>
          </button>
          
          {/* Decorative line */}
          <div className="mt-6 h-1 w-24 bg-gray-300 rounded-full" />
        </div>
      </div>
    </div>
  );
};

export default GalleryPlaceholder;